<template>
  <div id="nav">
    <HerderView />
    <router-view />
    <NowLoading v-show="isLoading" />
    <template v-if="alertModal.showModal">
      <AlertModal :contents="alertModal.message" />
    </template>
    <template v-if="confirmModal.showModal">
      <ConfirmModal :contents="confirmModal.message" :callback="confirmModal.callback" />
    </template>
    <FooterView />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import './assets/css/common.css';
import NowLoading from '@/molecules/NowLoading';
import AlertModal from '@/molecules/AlertModal';
import ConfirmModal from '@/molecules/ConfirmModal';
import HerderView from '@/molecules/HerderView';
import FooterView from '@/molecules/FooterView';
import Constants from '@/constants';

export default {
  components: {
    NowLoading,
    AlertModal,
    ConfirmModal,
    HerderView,
    FooterView,
  },
  computed: mapGetters({
    isLoading: 'getIsLoading',
    alertModal: 'getAlertModal',
    confirmModal: 'getConfirmModal',
  }),
  mounted() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (Constants.ENABLE_MBILE_SITE === "true" && (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1)) {
      this.$store.commit('setIsMobile', true);
    } else {
      this.$store.commit('setIsMobile', false);
    }
  },
}
</script>
